// extracted by mini-css-extract-plugin
export default {"fullWidth":"hp-z","image":"ip-z","lazyLoadPicture":"jp-z","lazyLoadSpinner":"kp-z","lazyLoadSpin":"lp-z","lazyLoadImage":"mp-z","hasStyledAspectRatio":"np-z"};